<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Translation!</p>
                <button class="delete" aria-label="close" @click="closeModal"></button>
            </header>
            <section class="modal-card-body">
                <div class="columns">
                    <div class="column">
                        <figure class="image">
                            <img :src="lot.auction_list !== undefined ? lot.auction_list.split('#')[0] : lot.pictures.split('#')[0]">
                        </figure>
                    </div>
                    <div class="column">
                        <div class="field">
                            <div class="control">
                        <textarea class="textarea" placeholder="Please wright translation"
                                  v-model="translation.body" :readonly="!isAdmin && !isSalesStaff"
                        ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-primary"
                        v-bind:class="{ 'is-loading': isLoading }"
                        v-if="!isTranslated && (isAdmin || isSalesStaff)"
                        @click="createNewTranslation">Post</button>
                <button class="button is-info"
                        v-bind:class="{ 'is-loading': isLoading }"
                        v-if="isTranslated && (isAdmin || isSalesStaff)"
                        @click="updateTranslation">Update</button>
                <button class="button" @click="closeModal">Cancel</button>
            </footer>
        </div>
    </div>
</template>

<script>
    import apiTranslations from './../../api/apiTranslations.js'
    export default {
        props: ['lot', 'lot_id'],
        data() {
           return {
              isLoading: false,
              translation: (this.lot.translation ? this.lot.translation : { lot_id: this.lot_id, body: null })
           }
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            },
            isActive() {
                return this.$store.getters.getTranslateModalStatus(this.lot_id)
            },
            isTranslated() {
                return this.lot.translation !== null
            }
        },
        methods: {
            closeModal() {
                this.$store.dispatch('changeTranslateModalStatus', {status: false, bidId: ''})
            },
            createNewTranslation() {
                this.isLoading = true
                apiTranslations
                    .placeTranslationRequest(this.translation)
                    .then((response) => {
                        this.translation = response.data
                        this.isLoading = false
                        this.lot.translation = response.data
                    })
                    .catch(error => {
                        console.log(error)
                        this.isLoading = false
                    })
            },
            updateTranslation() {
                this.isLoading = true
                apiTranslations
                    .updateTranslationRequest(this.translation)
                    .then((response) => {
                        this.translation = response.data
                        this.isLoading = false
                        this.lot.translation = response.data
                    })
                    .catch(error => {
                        console.log(error)
                        this.isLoading = false
                    })
            }
        },
        created () {
            if (this.lot.translation !== null) {
                this.translation.body = this.lot.translation.body
            }
        }
    }
</script>

<style scoped>
    .modal-card {
        width: 90%;
    }
    .image {
        padding-bottom: 20px;
        float: left;
    }
    .textarea {
        min-height: 600px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Favorites/TranslateFavoriteModal.vue